import { paths } from '@/config/paths'
import { cn } from '@/ui/utils/style'
import { FeedbackFish } from '@feedback-fish/react'
import { PageLinkType } from '../types'
import { focusVariants, PageLink, textVariants } from './nav-link/NavLink'
import { ArrowRightLeftIcon, LayoutGridIcon, MessageSquareIcon, DropletIcon, ArrowDownUpIcon } from 'lucide-react'
import StakingIcon from '@/ui/assets/staking.svg'
import TransferIcon from '@/ui/assets/transfer.svg'
import MarketsNavIcon from '@/ui/assets/markets-nav.svg'

import { isTestnet } from '@/config/consts'

export interface PageLinksProps {
  mobileMenuCollapsed: boolean
  closeMobileMenu: () => void
}

const links: PageLinkType[] = [
  {
    to: paths.easyBorrow,
    label: 'Quick borrow',
    icon: ArrowRightLeftIcon,
  },
  {
    to: paths.dashboardPooled,
    label: 'Dashboard',
    icon: LayoutGridIcon,
  },
  {
    label: 'Markets',
    icon: MarketsNavIcon,
    group: [
      { label: 'Pooled markets', to: paths.marketsPooled },
      { label: 'Isolated markets', to: paths.marketsIsolated },
    ],
  },
  {
    label: 'Vaults',
    icon: StakingIcon,
    to: paths.vaults,
  },
  {
    to: paths.swap,
    label: 'Swap',
    icon: ArrowDownUpIcon,
  },
  {
    to: paths.transfer,
    label: 'Transfer',
    icon: TransferIcon,
  },

  ...(isTestnet
    ? [
        {
          to: paths.faucet,
          label: 'Faucet',
          icon: DropletIcon,
        },
      ]
    : []),
] as const

export function PageLinks({ mobileMenuCollapsed, closeMobileMenu }: PageLinksProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-1 flex-col items-start gap-2 pb-3 xl:gap-6 xl:pb-0',
        mobileMenuCollapsed && 'hidden xl:flex',
      )}
    >
      {links.map((link) => (
        <PageLink key={link.label} link={link} closeMobileMenu={closeMobileMenu} />
      ))}

      <FeedbackFish projectId={process.env.NEXT_PUBLIC_FEEDBACK_FISH_PROJECT_ID || ''}>
        <button
          className={cn(
            focusVariants(),
            textVariants({ selected: false, isPlaceholder: false }),
            'flex cursor-pointer items-center gap-4 p-3 xl:p-0',
          )}
        >
          <MessageSquareIcon className="h-5 w-5" /> Give Feedback
        </button>
      </FeedbackFish>
    </div>
  )
}
